import './styling/travelStyling.scss';

import { FC } from 'react';
import { Control, FieldErrors } from 'react-hook-form';
import { Box, Label, Title } from '@gjensidige/builders-components';

import { Datepicker, Input, InputGroup, Textarea } from '../../../components';
import { insuranceUserOptions, travelPurposeOptions } from '../../../constants';
import { EquinorTravelValues } from '../../../utils/types';
import { TravelHeader } from '../components/TravelHeader';
import { PersonDetails } from './PersonDetails';

interface OtherProps {
  control: Control<EquinorTravelValues>;
  errors: FieldErrors<EquinorTravelValues>;
}

const Other: FC<OtherProps> = ({ control, errors }) => {
  return (
    <>
      <TravelHeader
        headerTitle="Other"
        description="None of the other options matched your incident."
      />
      <PersonDetails control={control} errors={errors} />
      <Box variant="form-section" className="form-section">
        <Title as="h4" size="5">
          Claim Details
        </Title>
        <InputGroup
          name="injuredParty"
          control={control}
          labelText="To whom did the incident occur"
          options={insuranceUserOptions}
          type="radio"
          variant="column"
          tracking={false}
          error={errors.injuredParty}
        />
        <Label>
          If the incident did not happen to you, add the name and birthdate of the one affected –
          Optional
        </Label>
        <Input
          name="affectedFullName"
          control={control}
          labelText="Full name"
          type="text"
          error={errors.affectedFullName}
          tracking={false}
        />
        <Input
          name="affectedDateOfBirth"
          control={control}
          labelText="Date of birth"
          type="text"
          tracking={false}
          error={errors.affectedDateOfBirth}
        />
        <Datepicker
          name="incidentDate"
          control={control}
          labelText="When did the incident occur? (dd/mm/yyyy)"
          format="dd/MM/yyyy"
          formatDayJs="DD/MM/YYYY"
          error={errors.incidentDate}
        />
        <Input
          name="country"
          control={control}
          labelText="In which country did the incident occur?"
          type="text"
          tracking={false}
          error={errors.country}
        />
        <InputGroup
          name="travelPurpose"
          control={control}
          labelText="What was the purpose of the trip?"
          options={travelPurposeOptions}
          type="radio"
          variant="column"
          tracking={false}
          error={errors.travelPurpose}
        />
        <Datepicker
          name="tripStartBookedDate"
          control={control}
          labelText="When did the trip start? (dd/mm/yyyy)"
          format="dd/MM/yyyy"
          formatDayJs="DD/MM/YYYY"
          error={errors.tripStartBookedDate}
        />
        <Datepicker
          name="tripEndCancelledDate"
          control={control}
          labelText="When did the trip end? (dd/mm/yyyy)"
          helpText="If you are still traveling, choose your planned trip end date"
          format="dd/MM/yyyy"
          formatDayJs="DD/MM/YYYY"
          error={errors.tripEndCancelledDate}
        />
        <Input
          name="compensation"
          control={control}
          labelText="Add the amount you are seeking compensation for"
          type="text"
          tracking={false}
          error={errors.compensation}
        />
        <Textarea
          name="detailedIncidentDescription"
          control={control}
          labelText="Describe what happened in detail"
          maxWarning={500}
          error={errors.detailedIncidentDescription}
        />
      </Box>
    </>
  );
};

export default Other;
